import { render, staticRenderFns } from "./RecurEventSettings.vue?vue&type=template&id=5c0d46de"
import script from "./RecurEventSettings.vue?vue&type=script&lang=js"
export * from "./RecurEventSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports